"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrainerSnapshot = void 0;
const react_1 = require("react");
const TrainerContext_1 = require("../TrainerContext");
function useTrainerSnapshot(selector = (snapshot) => snapshot) {
    const trainer = (0, TrainerContext_1.useTrainerContext)();
    const snapshot = (0, react_1.useSyncExternalStore)(trainer.subscribe, trainer.getSnapshot, trainer.getSnapshot);
    return selector(snapshot);
}
exports.useTrainerSnapshot = useTrainerSnapshot;
